import { render, staticRenderFns } from "./MarketLayout.vue?vue&type=template&id=4cb6bf0e&scoped=true&"
import script from "./MarketLayout.vue?vue&type=script&lang=js&"
export * from "./MarketLayout.vue?vue&type=script&lang=js&"
import style0 from "./MarketLayout.vue?vue&type=style&index=0&id=4cb6bf0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb6bf0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomNavigation,VBtn,VContainer,VDialog,VIcon})
